import PropTypes from 'prop-types'
import EtapForm from '../parts/EtapForm.jsx'

export const EtapInicjacji = (props) => {
    return <EtapForm wiz={props.wiz} etapKey="inicjacja" />
}

EtapInicjacji.propTypes = {
    wiz: PropTypes.any,
}
